import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Link to a section of the landing page ("#invest"): an in-page anchor when already on "/",
// otherwise a route change to "/#invest" (the landing page scrolls to the hash on arrival).
const HomeSectionLink = ({ hash, className, children, ...rest }) => {
  const { pathname } = useLocation();

  if (pathname === '/') {
    return (
      <a className={className} href={hash} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={hash === '#top' ? '/' : `/${hash}`} {...rest}>
      {children}
    </Link>
  );
};

export default HomeSectionLink;
